import { createApp } from 'vue'
import App from './App.vue'
import i18n from './plugins/i18n'
import router from './router'
import pinia from './store/pinia'

import { MarcaCoronaPreset } from '@/presets/marca-corona'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'

import '@/assets/styles.scss'

const app = createApp(App)

app.use(pinia)
app.use(i18n)
app.use(router)
app.use(PrimeVue, {
    locale: {
        firstDayOfWeek: 1
    },
    theme: {
        preset: MarcaCoronaPreset,
        options: {
            prefix: 'p',
            darkModeSelector: '.app-dark',
            cssLayer: false
        }
    }
});
app.use(ToastService)
app.use(ConfirmationService)

app.mount('#app')
